import { gql, useQuery } from '@apollo/client';
import { useRouter } from 'next/router';
import * as React from 'react';

import { Loading } from '@/imports/ui/chakra/components/Loading';

import {
  ConferenceControllerRedirect_Event,
  ConferenceControllerRedirect_EventVariables,
} from './graphql-types/ConferenceControllerRedirect_Event';

import { useConferenceContentPropertiesExist } from '../../conference/hooks/useConferenceContentPropertiesExist';

const EVENT = gql`
  query ConferenceControllerRedirect_Event($input: EventInput!) {
    event(input: $input) {
      eventV2 {
        _id
        ... on ConferenceEventV2 {
          _id
          ...useConferenceContentPropertiesExist_ConferenceEventFragment
        }
      }
    }
  }
  ${useConferenceContentPropertiesExist.conferenceEventFragment}
`;

export const ConferenceControllerRedirect: React.FC = () => {
  const router = useRouter();
  const eventId = router.query.eventId.toString();
  const { data } = useQuery<
    ConferenceControllerRedirect_Event,
    ConferenceControllerRedirect_EventVariables
  >(EVENT, {
    variables: {
      input: {
        _id: eventId,
      },
    },
  });

  const { hasSessions, hasBooths, hasDescription, hasVisibleSpeakers } =
    useConferenceContentPropertiesExist(
      (data?.event.eventV2?.__typename === 'ConferenceEventV2' &&
        data.event.eventV2) ||
        undefined
    );

  React.useEffect(() => {
    if (hasDescription || hasVisibleSpeakers) {
      router.replace({
        pathname: `/events/conferences/[eventId]/overview`,
        query: router.query,
      });
    } else if (hasSessions) {
      router.replace({
        pathname: `/events/conferences/[eventId]/sessions`,
        query: router.query,
      });
    } else if (hasBooths) {
      router.replace({
        pathname: `/events/conferences/[eventId]/expo`,
        query: router.query,
      });
    } else {
      router.replace({
        pathname: `/events/conferences/[eventId]/overview`,
        query: router.query,
      });
    }
  }, [
    eventId,
    hasBooths,
    hasDescription,
    hasSessions,
    hasVisibleSpeakers,
    router,
  ]);

  return <Loading />;
};
